export default `@charset "UTF-8";
/* Ids List Box Component */
.label-state-hidden .ids-label-text.empty::before {
  content: " ";
}

:host([label-state=collapsed]) .ids-input label {
  display: none;
  width: 0;
}

:host([label-state=collapsed][label-position=inline-start][label-alignment=end]) .ids-input {
  gap: 0;
}

:host([label-state=collapsed][label-position=inline-start][label-alignment=end][label-wrap=ellipsis-no-stretch]) .ids-input .ids-label-text {
  margin-inline-end: 0;
}

:host {
  display: block;
  min-width: calc(var(--ids-input-width-10) - 2px);
  width: var(--ids-input-width-full);
  font-weight: normal;
  height: auto;
  overflow-x: hidden;
  overflow-y: auto;
  max-height: var(--ids-list-box-max-height, var(--ids-input-width-40));
}

.ids-list-box {
  display: flex;
  flex-direction: column;
  font-weight: normal;
  height: auto;
  min-height: 0;
}

.field-container {
  display: block;
  position: relative;
  overflow: hidden;
  flex: 0 0 auto;
  min-height: 0;
}

.ids-label-text {
  display: block;
  margin-block-end: var(--ids-input-margin-bottom);
  color: var(--ids-input-label-color-text-default);
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  font-size: var(--ids-input-label-font-size);
  font-weight: var(--ids-input-label-font-weight);
}
.ids-label-text.empty {
  display: none;
}

:host([label-position=inline-start]) .ids-list-box {
  flex-direction: row;
  align-items: var(--ids-label-align-y, flex-start);
  gap: var(--ids-space-xs);
}
:host([label-position=inline-start]) .ids-label-text {
  flex: 0 0 auto;
  width: var(--ids-label-width, auto);
  margin: var(--ids-space-none);
  padding-block: var(--ids-label-padding-block);
  box-sizing: border-box;
}
:host([label-position=inline-start]) .field-container {
  flex: 1 1 auto;
  min-width: 0;
}

:host([label-position=inline-end]) .ids-list-box {
  flex-direction: row;
  align-items: var(--ids-label-align-y, flex-start);
  gap: var(--ids-space-xs);
}
:host([label-position=inline-end]) .ids-label-text {
  flex: 0 0 auto;
  width: var(--ids-label-width, auto);
  margin: var(--ids-space-none);
  padding-block: var(--ids-label-padding-block);
  box-sizing: border-box;
  order: 2;
}
:host([label-position=inline-end]) .field-container {
  flex: 1 1 auto;
  min-width: 0;
  order: 1;
}

:host([label-wrap=ellipsis]) .ids-label-text,
:host([label-wrap=ellipsis-no-stretch]) .ids-label-text {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

:host([label-wrap=wrap]) .ids-label-text {
  overflow-wrap: anywhere;
}

.label-state-hidden .ids-label-text {
  display: flex;
  visibility: hidden;
}
.label-state-hidden .ids-label-text.empty::before {
  content: " ";
}

.label-state-collapsed .ids-label-text {
  display: none;
  margin: var(--ids-space-none);
}

:host(.not-embedded.is-table) .field-container {
  display: flex;
  flex-direction: column;
  overflow-x: auto;
  overflow-y: auto;
}

:host(.not-embedded.is-table) ::slotted(ids-list-box-option) {
  display: table-row;
  width: 100%;
  min-width: max-content;
}

:host(.not-embedded.is-table) ::slotted(ids-list-box-option span) {
  display: table-cell;
}

:host(.not-embedded) .field-container {
  overflow-y: auto;
  height: calc(var(--ids-list-box-height, auto) - 2px);
  max-height: var(--ids-list-box-max-height, var(--ids-input-width-40));
  border: 1px solid var(--ids-list-box-color-border-default);
  border-radius: var(--ids-list-box-border-radius);
  background-color: var(--ids-list-box-color-background-default);
  transition: border-color var(--ids-motion-duration) var(--ids-motion-ease), box-shadow var(--ids-motion-duration) var(--ids-motion-ease);
}

:host(.not-embedded) ::slotted(ids-list-box-option) {
  border: 1px solid transparent;
}

:host(.not-embedded) ::slotted(ids-list-box-option:hover) {
  background-color: var(--ids-list-box-color-background-hover);
}

:host(.not-embedded) ::slotted(ids-list-box-option[selected]) {
  background-color: var(--ids-list-box-color-background-selected);
  color: var(--ids-list-box-color-text-selected);
}

:host(.not-embedded) ::slotted(ids-list-box-option:focus) {
  border-color: var(--ids-list-box-color-border-focus);
  box-shadow: var(--ids-list-box-shadow-focus);
  width: calc(100% - 2px);
}

:host(.not-embedded) ::slotted(ids-list-box-option.multi-column-option:focus) {
  outline: 1px solid var(--ids-list-box-color-border-focus);
  box-shadow: var(--ids-list-box-shadow-focus);
  border-color: transparent;
}

:host(.multi-column:not(.not-embedded)),
:host(.not-embedded.is-table) {
  overflow-x: auto;
}
:host(.multi-column:not(.not-embedded)) .field-container,
:host(.not-embedded.is-table) .field-container {
  overflow: auto;
  max-height: var(--ids-list-box-max-height, var(--ids-input-width-40));
}

:host(.is-datagrid[field-height=xs]) ::slotted(ids-list-box-option),
:host(.is-datagrid[field-height=xxs]) ::slotted(ids-list-box-option) {
  font-size: var(--ids-font-size-xs);
}

:host([size=xs]),
:host([size=xs]) ::slotted(ids-list-box-option) {
  max-width: calc(var(--ids-input-width-10) - 2px);
}

:host([disabled]:not([disabled=false])) {
  cursor: var(--ids-cursor-default);
  opacity: 0.5;
  pointer-events: none;
}

:host([size=sm]),
:host([size=sm]) ::slotted(ids-list-box-option) {
  max-width: calc(var(--ids-input-width-20) - 2px);
}

:host([size=md]),
:host([size=md]) ::slotted(ids-list-box-option) {
  max-width: calc(var(--ids-input-width-40) - 2px);
  min-height: 32px;
}

:host([size=mm]),
:host([size=mm]) ::slotted(ids-list-box-option) {
  max-width: calc(var(--ids-input-width-30) - 2px);
}

:host([size=lg]),
:host([size=lg]) ::slotted(ids-list-box-option) {
  max-width: calc(var(--ids-input-width-50) - 2px);
}

:host([size=full]),
:host([size=full]) ::slotted(ids-list-box-option) {
  max-width: var(--ids-input-width-full);
}

:host([auto-size=true]),
:host([auto-size=true]) ::slotted(ids-list-box-option) {
  max-width: none;
}

:host([input-auto-size=false]) ::slotted(ids-list-box-option) {
  margin-inline-end: 8px;
}

:host([field-height=xxs]) ::slotted(ids-list-box-option) {
  font-size: var(--ids-dropdown-font-size-compact);
  min-height: calc(var(--ids-input-height-10) - 2px);
  line-height: calc(var(--ids-input-height-10) - 2px);
  text-indent: 2px;
}

:host([compact]) ::slotted(ids-list-box-option),
:host([field-height=xs]) ::slotted(ids-list-box-option) {
  font-size: var(--ids-dropdown-font-size-compact);
  min-height: calc(var(--ids-input-height-10) - 2px);
  line-height: calc(var(--ids-input-height-10) - 2px);
  text-indent: 4px;
}

:host([field-height=sm]) ::slotted(ids-list-box-option) {
  min-height: calc(var(--ids-input-height-20) - 2px);
  line-height: calc(var(--ids-input-height-20) - 2px);
  text-indent: 10px;
}

:host([field-height=md]) ::slotted(ids-list-box-option) {
  min-height: calc(var(--ids-input-height-30) - 2px);
  line-height: calc(var(--ids-input-height-30) - 2px);
}

:host([field-height=lg]) ::slotted(ids-list-box-option) {
  min-height: calc(var(--ids-input-height-40) - 2px);
  line-height: calc(var(--ids-input-height-40) - 2px);
}

:host([uppercase]) ::slotted(ids-list-box-option) {
  text-transform: uppercase;
}

:host(.module-nav) {
  max-height: none;
}
:host(.module-nav) .field-container {
  max-height: none;
}

:host(ids-list-box) ids-text.first-selected {
  display: block;
  padding: 5px 9px;
}

::slotted(ids-text.first-selected) {
  display: block;
  padding: 5px 9px;
}

::slotted(ids-list-box-option[selected].last-selected) {
  margin-bottom: var(--ids-dropdown-group-padding);
}

::slotted(ids-list-box-option.ellipsis) {
  overflow: hidden;
  text-overflow: ellipsis;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
